import { NgModule } from '@angular/core';
import { PepperiIconComponent } from './icon.component';

@NgModule({
  declarations: [PepperiIconComponent],
  imports: [
  ],
  exports: [PepperiIconComponent]
})
export class PepperiIconModule { }
